import bananaIcon from '../assets/nano-icon.webp';
import gptIcon from '../assets/openai-bai.svg';

export default function ModelIcon({ modelId, className = '' }) {
  const id = String(modelId || '').toLowerCase();
  if (id.startsWith('midjourney') || id === 'mj') {
    return <span className={`model-mj-mark ${className}`.trim()} aria-hidden="true">MJ</span>;
  }
  const isGpt = id.includes('gpt') || id.includes('image-2');
  const source = isGpt ? gptIcon : bananaIcon;

  return (
    <img
      className={`model-brand-icon ${isGpt ? 'model-brand-icon--gpt' : ''} ${className}`.trim()}
      src={source}
      alt=""
      aria-hidden="true"
      draggable="false"
    />
  );
}
